import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpResponse } from '@angular/common/http';
import { AuthChangePasswordRequest, AuthChangePasswordResponse } from '../../domain/dto';
import { AuthRepository } from '../../domain/repository';

@Injectable({ providedIn: 'root' })
export class ChangePasswordUseCase {
  constructor(private authRepository: AuthRepository) {}

  execute(
    request: AuthChangePasswordRequest,
  ): Observable<HttpResponse<AuthChangePasswordResponse>> {
    return this.authRepository.changePassword(request);
  }
}


